'use strict';

const _=require('pulsar-utils/dist-es6/_');
const IncidentViewModel=require('../../../../../../dist-es6/client/viewModels/incidentViewModel');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const SortExtensions=require('../../../../../../dist-es6/client/extensions/sortExtensions');
const StatisticsPanelHelpers=require('../../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

IncidentsScheduleDirective=class IncidentsScheduleDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'multiViewParent',
'personalSchedule',
'groupMemberships',
'homeTimezone',
'fatigueThreshold',
'deviationThreshold',
'personInfo'];

}

get templateUrl(){
return'/templates/features/personalSchedule/components/incidentsSchedule/incidentsScheduleView';
}

get controller(){
return IncidentsScheduleDirectiveController;
}};let


IncidentsScheduleDirectiveController=class IncidentsScheduleDirectiveController{
constructor($state,$scope,$timeout,$element,elementService,intervalService,timeZoneService,personalIncidentsService,displaySettingsService){
this._$state=$state;
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
this._elementService=elementService;
this._intervalService=intervalService;
this._timeZoneService=timeZoneService;
this._personalIncidentsService=personalIncidentsService;

this._use24HourTimeline=displaySettingsService.use24HourTimeline;

this.getDateStringFor=this.getDateStringFor.bind(this);
this.getTimeStringFor=this.getTimeStringFor.bind(this);
this.sortByTimeOfDay=this.sortByTimeOfDay.bind(this);
this._sortByDescendingFatigueScore=SortExtensions(this.sortByFatigueScore).invert();
this._sortByDescendingUnixTime=SortExtensions(this.sortByUnixTime).invert();
this.statisticsPanelDimensions=StatisticsPanelHelpers.MinimumStatisticsPanelDimensions;

this.tableColumnDefinitions=[{
label:'Date',
defaultAscending:!1,
orderBy:[this.sortByUnixTime],
columnClass:'date-column',
finalSort:[this._sortByDescendingFatigueScore],
isInitiallyActive:!0},
{
label:'Time',
defaultAscending:!0,
orderBy:[this.sortByTimeOfDay],
finalSort:['description'],
columnClass:'time-column'},
{
label:'Type',
defaultAscending:!0,
orderBy:['description'],
finalSort:[this._sortByDescendingFatigueScore,this._sortByDescendingUnixTime],
columnClass:'type-column'},
{
label:'Fatigue at Time of Incident',
defaultAscending:!1,
orderBy:[this.sortByFatigueScore],
finalSort:[this._sortByDescendingUnixTime],
columnClass:'fatigue-column'}];


this._loadIncidents();
}

get directiveElement(){
return this._directiveElement||(this._directiveElement=this._elementService.selectElement('.current-view')[0]);
}

async _loadIncidents(){
const{incidents,incidentTypes,dayOfLastPurgedIncident}=await this._personalIncidentsService.getAllIncidentsFor(this.personId);

const validIncidentInterval=this._intervalService.getMonthlyLookbackIntervalIncludingCurrentDayFor(this.homeTimezone,StatisticsPanelHelpers.TotalMonthsToDisplayInGraph);

const{
filteredIncidents,
finalIncidentBeforeInterval}=
StatisticsPanelHelpers.filterSortedIncidentsToIntervalPlusOneBefore(incidents,validIncidentInterval);

const daysSinceLastIncidentPathStartTime=StatisticsPanelHelpers.getPathStartTimeForDaysSinceGraph(
_.get(finalIncidentBeforeInterval,'time'),
_.exists(dayOfLastPurgedIncident)?dayOfLastPurgedIncident.startOfDayInTimezone(this.homeTimezone):null,
_.get(this.personalSchedule,'bounds.start'),
this.personInfo.creationTime);

const incidentViewModels=filteredIncidents.map(i=>IncidentViewModel.createFrom(i,{code:i.code,description:i.description},this.timezone,_.noop));
for(const ivm of incidentViewModels){
ivm.currentlyScopedGroupMemberships=this.groupMemberships;
}

this._$timeout(()=>{
this._incidents=incidentViewModels;
this._incidentTypes=incidentTypes;
this._incidentInterval=validIncidentInterval;
this._daysSinceLastIncidentPathStartTime=daysSinceLastIncidentPathStartTime;
});
}

get displayStatisticsPanels(){
return _.exists(this.incidentInterval)&&
_.exists(this.filteredIncidents)&&
_.get(this.incidentTypes,'length')>0&&(
_.get(this.filteredIncidents,'length')>0||_.get(this.searchQuery,'length')===0);
}

async goToIncident(incident){
await this._$state.go('fdc.features.personalSchedule',{
interval:TimeInterval.fromPoint(incident.time),
personalScheduleTabSelection:-1});

}

getDateStringFor(item){
const dayOfWeek=Formatters.dayOfWeekInTimeZone(item.time,this.homeTimezone).toUpperCase();
const monthDayYear=Formatters.formatInLocale(item.time,'MMM DD, YYYY',this.homeTimezone,{displayTimeZone:!1});

return`${dayOfWeek} ${monthDayYear}`;
}

getTimeStringFor(item){
return Formatters.timeInLocale(item.time,this.homeTimezone,!1,this._use24HourTimeline);
}

sortByUnixTime(item){
return item.time.getTime();
}

sortByFatigueScore(item){
return Math.floor(item.fatigue)||Number.NEGATIVE_INFINITY;
}

sortByTimeOfDay(item){
return parseInt(Formatters.formatInLocale(item.time,`HHmm`,this.timezone),10);
}

_getFatigueThresholdStatusFor(incident){
return ThresholdStatus.fromScoreAndThreshold(incident.fatigue,this.fatigueThreshold);
}

_getDeviationThresholdStatusFor(incident){
const fatigueHistory=_.get(incident.statistics,'recentHistory.fatigue');
const effectiveDeviationThreshold=ThresholdStatus.getEffectiveDeviationThresholdFrom(fatigueHistory,this.deviationThreshold);
return ThresholdStatus.fromScoreAndThreshold(incident.fatigue,effectiveDeviationThreshold);
}

_getDeviationFor(incident){
const fatigueHistory=_.get(incident.statistics,'recentHistory.fatigue');
const effectiveDeviationThreshold=ThresholdStatus.getEffectiveDeviationThresholdFrom(fatigueHistory,this.deviationThreshold);
return ThresholdStatus.getDeviationFromEffectiveThreshold(incident.fatigue,effectiveDeviationThreshold);
}

get incidents(){
return this._incidents;
}

get incidentInterval(){
return this._incidentInterval;
}

get incidentTypes(){
return this._incidentTypes;
}

get daysSinceLastIncidentPathStartTime(){
return this._daysSinceLastIncidentPathStartTime;
}

get timezone(){
return this._$state.params.timezone;
}

get interval(){
return this._$state.params.interval;
}

get personId(){
return this._$state.params.id;
}};


module.exports=IncidentsScheduleDirective;
//# sourceMappingURL=incidentsScheduleDirective.js.map
